import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { mapBoxProps, BaseBoxProps } from '../_commons/BaseBox';
import { StyledProps } from '@front10';

export interface RowProps {
  gutters: boolean;
}

function Row(props: StyledProps<RowProps & BaseBoxProps>) {
  const { gutters } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const newClassName = `fr-row ${!gutters ? 'fr-no-gutters' : ''} ${className}`;
  return <div {...mapBoxProps(props)} className={newClassName} style={style} />;
}

Row.defaultProps = {
  gutters: false,
  children: null,
};

Row.componentName = 'Row';

export default Row;
